var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLicense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.1305 33.4668C100.866 33.4668 102.273 34.8739 102.273 36.6097V78.8335C102.273 84.7664 97.4368 89.7494 91.3575 89.7494H25.5266C23.7909 89.7494 22.3838 88.3423 22.3838 86.6066C22.3838 84.8708 23.7909 83.4637 25.5266 83.4637H91.3575C93.9149 83.4637 95.9877 81.3454 95.9877 78.8335V36.6097C95.9877 34.8739 97.3948 33.4668 99.1305 33.4668Z",
    fill: "#D2E5F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.112 85.1668C16.4098 85.1668 12.5713 81.3283 12.5713 76.6261V46.2057V32.195C12.5713 27.4928 16.4098 23.6543 21.112 23.6543H28.8851H89.0541C93.7563 23.6543 97.5948 27.4928 97.5948 32.195V76.5301C97.5948 81.2323 93.7563 85.0709 89.0541 85.0709H21.112V85.1668Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1123 25.0678C17.1911 25.0678 13.9858 28.2732 13.9858 32.1943V76.6253C13.9858 80.1495 16.575 83.0955 19.946 83.6558H89.0543C92.9754 83.6558 96.1808 80.4505 96.1808 76.5294V32.1943C96.1808 28.2732 92.9754 25.0678 89.0543 25.0678H21.1123ZM22.5265 86.4844H89.0543C94.5376 86.4844 99.0093 82.0126 99.0093 76.5294V32.1943C99.0093 26.711 94.5376 22.2393 89.0543 22.2393H21.1123C15.629 22.2393 11.1572 26.711 11.1572 32.1943V76.6253C11.1572 82.1086 15.629 86.5803 21.1123 86.5803H22.5265V86.4844Z",
    fill: "#3694E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4355 70.5714C24.4355 69.7036 25.1391 69 26.007 69H45.9674C46.8352 69 47.5388 69.7036 47.5388 70.5714C47.5388 71.4393 46.8352 72.1429 45.9674 72.1429H26.007C25.1391 72.1429 24.4355 71.4393 24.4355 70.5714Z",
    fill: "#DEE9F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4355 54.5714C24.4355 53.7036 25.1391 53 26.007 53H83.4022C84.2701 53 84.9736 53.7036 84.9736 54.5714C84.9736 55.4393 84.2701 56.1429 83.4022 56.1429H26.007C25.1391 56.1429 24.4355 55.4393 24.4355 54.5714Z",
    fill: "#DEE9F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85 67H82V73H85V67Z",
    fill: "#DEE9F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58 67H56V73H58V67Z",
    fill: "#DEE9F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66 67H59V73H66V67Z",
    fill: "#DEE9F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74 67H69V73H74V67Z",
    fill: "#DEE9F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79 67H76V73H79V67Z",
    fill: "#DEE9F2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4355 62.5714C24.4355 61.7036 25.1391 61 26.007 61H83.4022C84.2701 61 84.9736 61.7036 84.9736 62.5714C84.9736 63.4393 84.2701 64.1429 83.4022 64.1429H26.007C25.1391 64.1429 24.4355 63.4393 24.4355 62.5714Z",
    fill: "#DEE9F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 36.3917C41 35.5239 41.7036 34.8203 42.5714 34.8203H83.9667C84.8345 34.8203 85.5381 35.5239 85.5381 36.3917V45.771C85.5381 46.6389 84.8345 47.3424 83.9667 47.3424H42.5714C41.7036 47.3424 41 46.6389 41 45.771V36.3917ZM44.1429 37.9632V44.1996H82.3952V37.9632H44.1429Z",
    fill: "#DEE9F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1351 46.7007H27.8649C25.7838 46.7007 24 44.9169 24 42.8358V39.5656C24 37.4845 25.7838 35.7007 27.8649 35.7007H31.1351C33.2162 35.7007 35 37.4845 35 39.5656V42.8358C35 44.9169 33.5135 46.7007 31.1351 46.7007Z",
    fill: "#2DD68A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicense);
export default __webpack_public_path__ + "static/media/license.d9582bd28babd756281b3a31e76d8109.svg";
export { ForwardRef as ReactComponent };